import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAuFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M49.1378 41.3461H0.862108C0.386034 41.3461 0 40.9609 0 40.4858V9.51417C0 9.03906 0.386034 8.65381 0.862108 8.65381H49.1379C49.614 8.65381 50 9.03906 50 9.51417V40.4858C49.9999 40.961 49.6139 41.3461 49.1378 41.3461Z",
			fill: "#41479B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.1378 8.65381H22.6403L14.655 13.8751V8.65381H10.3447V13.8751L2.35937 8.65381H0.862106C0.386034 8.65381 0 9.03896 0 9.51408V10.1965L6.85105 14.676H0V18.9776H6.85105L0 23.4572V24.1396C0 24.6147 0.386034 25 0.862106 25H2.35956L10.3449 19.7787V25H14.6552V19.7787L22.6404 25H24.1379C24.614 25 25 24.6147 25 24.1396V23.4572L18.149 18.9777H24.9999V14.6761H18.1489L24.9999 10.1966V9.51417C24.9999 9.03897 24.6139 8.65381 24.1378 8.65381Z",
			fill: "#F3F3F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 15.5364H13.7931V8.65381H11.2069V15.5364H0V18.1173H11.2069V25H13.7931V18.1173H25V15.5364Z",
			fill: "#CD343C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.61539 14.423L0.416588 8.65381C0.171804 8.80344 0 9.05497 0 9.35558V9.39939L8.00983 14.423H9.61539Z",
			fill: "#CD343C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0626 14.423L24.9998 9.06713C24.8444 8.82448 24.5704 8.65381 24.2428 8.65381H24.0498L14.4229 14.423H16.0626Z",
			fill: "#CD343C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.93447 19.231L0 24.5766C0.154065 24.8251 0.432821 25.0002 0.765667 25.0002H0.934318L10.5769 19.231H8.93447Z",
			fill: "#CD343C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.0001 24.3112L16.9615 19.231H15.3848L24.5134 25.0002C24.7868 24.8766 24.9744 24.6177 25.0001 24.3112Z",
			fill: "#CD343C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6816 29.9456L13.319 32.1015L15.362 31.2679C15.5363 31.1968 15.6948 31.4004 15.5884 31.5586L14.3404 33.4133L16.2502 34.5298C16.4132 34.625 16.3566 34.8789 16.1695 34.8923L13.9758 35.0492L14.3145 37.275C14.3434 37.4649 14.1144 37.578 13.9875 37.4363L12.5 35.7772L11.0124 37.4363C10.8855 37.5779 10.6565 37.4648 10.6854 37.275L11.0242 35.0492L8.83043 34.8923C8.64329 34.8789 8.58674 34.625 8.74968 34.5298L10.6596 33.4133L9.41156 31.5586C9.30517 31.4004 9.46361 31.1968 9.63793 31.2679L11.6809 32.1015L12.3184 29.9456C12.373 29.7616 12.6272 29.7616 12.6816 29.9456Z",
			fill: "#F3F3F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.5526 14.4918L38.8714 15.5698L39.8927 15.153C39.9798 15.1175 40.0591 15.2192 40.0058 15.2984L39.3819 16.2258L40.3368 16.7841C40.4183 16.8316 40.39 16.9586 40.2964 16.9653L39.1996 17.0437L39.3689 18.1565C39.3834 18.2515 39.2688 18.308 39.2054 18.2372L38.4617 17.4077L37.7179 18.2372C37.6545 18.3079 37.54 18.2514 37.5544 18.1565L37.7237 17.0437L36.6269 16.9653C36.5333 16.9586 36.505 16.8316 36.5865 16.7841L37.5414 16.2258L36.9175 15.2984C36.8642 15.2192 36.9435 15.1175 37.0306 15.153L38.0519 15.5698L38.3707 14.4918C38.3983 14.3999 38.5255 14.3999 38.5526 14.4918Z",
			fill: "#F3F3F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.8602 22.1842L31.179 23.2621L32.2003 22.8454C32.2874 22.8099 32.3667 22.9116 32.3134 22.9908L31.6896 23.9182L32.6444 24.4765C32.7259 24.524 32.6976 24.651 32.604 24.6577L31.5072 24.7361L31.6765 25.8489C31.691 25.9439 31.5765 26.0004 31.513 25.9296L30.7693 25.1001L30.0255 25.9296C29.9621 26.0003 29.8476 25.9438 29.862 25.8489L30.0313 24.7361L28.9346 24.6577C28.8409 24.651 28.8126 24.524 28.8941 24.4765L29.849 23.9182L29.2251 22.9908C29.1718 22.9116 29.2511 22.8099 29.3382 22.8454L30.3596 23.2621L30.6783 22.1842C30.7059 22.0922 30.833 22.0922 30.8602 22.1842Z",
			fill: "#F3F3F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.283 19.2995L45.6018 20.3774L46.6232 19.9607C46.7102 19.9251 46.7895 20.0269 46.7363 20.106L46.1124 21.0334L47.0673 21.5917C47.1487 21.6393 47.1204 21.7663 47.0268 21.7729L45.93 21.8513L46.0994 22.9642C46.1139 23.0592 45.9993 23.1156 45.9359 23.0448L45.1922 22.2153L44.4484 23.0448C44.385 23.1155 44.2705 23.0591 44.2849 22.9642L44.4542 21.8513L43.3574 21.7729C43.2638 21.7663 43.2355 21.6393 43.317 21.5917L44.2719 21.0334L43.648 20.106C43.5947 20.0269 43.674 19.9251 43.7611 19.9607L44.7824 20.3774L45.1012 19.2995C45.1287 19.2075 45.2558 19.2075 45.283 19.2995Z",
			fill: "#F3F3F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.5526 32.7609L38.8714 33.8388L39.8927 33.422C39.9798 33.3865 40.0591 33.4882 40.0058 33.5674L39.3819 34.4948L40.3368 35.0531C40.4183 35.1007 40.39 35.2277 40.2964 35.2343L39.1996 35.3127L39.3689 36.4256C39.3834 36.5206 39.2688 36.5771 39.2054 36.5062L38.4617 35.6767L37.7179 36.5062C37.6545 36.577 37.54 36.5205 37.5544 36.4256L37.7237 35.3127L36.6269 35.2343C36.5333 35.2277 36.505 35.1007 36.5865 35.0531L37.5414 34.4948L36.9175 33.5674C36.8642 33.4882 36.9435 33.3865 37.0306 33.422L38.0519 33.8388L38.3707 32.7609C38.3983 32.6689 38.5255 32.6689 38.5526 32.7609Z",
			fill: "#F3F3F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.7483 24.1263L40.4592 25.0339L39.5453 25.0413C39.427 25.0423 39.3778 25.2003 39.4731 25.2739L40.2083 25.8422L39.9326 26.7543C39.8969 26.8725 40.0254 26.9701 40.1216 26.8981L40.8652 26.3418L41.6088 26.8981C41.705 26.9701 41.8334 26.8724 41.7978 26.7543L41.522 25.8422L42.2572 25.2739C42.3525 25.2002 42.3033 25.0423 42.1851 25.0413L41.2712 25.0339L40.982 24.1263C40.9445 24.0087 40.7857 24.0087 40.7483 24.1263Z",
			fill: "#F3F3F3"
		})
	]
});
const ForwardRef = forwardRef(SvgAuFlag);
export { ForwardRef as ReactComponent };
